"use client";

import { MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
const garages = [{
  id: 1,
  name: "Rathnew Garage",
  address: "Ballybeg, Rathnew A67Y602",
  phone: "0876789903",
  image: "https://markjohnstonmotors.ie/wp-content/uploads/2026/02/2.png?v=7ayddvstvvq"
}, {
  id: 2,
  name: "Blainroe Garage",
  address: "Blainroe - Old Vartry Garage",
  phone: "0876789903",
  image: "https://markjohnstonmotors.ie/wp-content/uploads/2026/02/3.png?v=bpfqoikop7k"
}, {
  id: 3,
  name: "Wicklow Town Garage",
  address: "New Street Wicklow Town",
  phone: "0876253228",
  image: "https://markjohnstonmotors.ie/wp-content/uploads/2026/02/4.png?v=u76rkvebj7i"
}];
export default function OurGarages() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  return <section id="our-garages" ref={ref} className={`py-16 md:py-24 bg-background transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-[36px] md:text-[48px] font-display font-bold leading-[1.2] mb-4">
            Our Garages
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
            Visit any of our three convenient locations across Wicklow for
            expert automotive service and repairs.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {garages.map((garage, i) => <CarouselItem key={garage.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="overflow-hidden group h-full">
                    <div className="relative overflow-hidden">
                      <img src={garage.image} alt={`${garage.name} exterior view`} className="w-full object-cover transition-transform duration-[200ms] ease-smooth group-hover:scale-[1.02] !h-[330px]" />
                      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-[200ms] ease-smooth flex items-center justify-center">
                        <Link to="#" className="inline-flex items-center gap-2 bg-secondary text-foreground px-6 py-3 rounded-md font-semibold hover:bg-secondary-hover transition-all duration-[100ms] ease-smooth">
                          <MapPin className="w-5 h-5" />
                          View Map
                        </Link>
                      </div>
                    </div>

                    <CardContent className="space-y-3">
                      <h3 className="font-display text-[24px] font-semibold leading-[1.3]">
                        {garage.name}
                      </h3>
                      <div className="space-y-2 text-muted-foreground text-sm">
                        <p className="flex items-start gap-2">
                          <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                          <span>{garage.address}</span>
                        </p>
                        <p className="font-medium text-foreground">
                          {garage.phone}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>

            <CarouselPrevious className="-left-12 hidden lg:flex" />
            <CarouselNext className="-right-12 hidden lg:flex" />
          </Carousel>

          <div className="mt-8 max-w-md mx-auto">
            <Progress value={(currentSlide + 1) / garages.length * 100} />
            <p className="text-center text-sm text-muted-foreground mt-2 whitespace-nowrap">
              Location {currentSlide + 1} of {garages.length}
            </p>
          </div>
        </div>
      </div>
    </section>;
}